import React, { PureComponent } from "react";
import styled from "styled-components";

import Selector from './selector';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  margin-bottom: 12px;
`;

export const SelectorLabel = styled.span`
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-right: 8px;
`;

class SelectorWrapper extends PureComponent {
  render() {
    const {
      label,
      options,
      onSelectorChange,
      selectedOptionId = null
    } = this.props;

    return (
      <Wrapper>
        <SelectorLabel>{label}</SelectorLabel>
        <Selector
          options={options}
          onSelectorChange={onSelectorChange}
          selectedOptionId={selectedOptionId}
        ></Selector>
      </Wrapper>
    );
  }
}

export default SelectorWrapper;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/selector-wrapper.js